import { render, staticRenderFns } from "./tjshdz.vue?vue&type=template&id=69a7067a&scoped=true&"
import script from "./tjshdz.vue?vue&type=script&lang=js&"
export * from "./tjshdz.vue?vue&type=script&lang=js&"
import style0 from "./tjshdz.vue?vue&type=style&index=0&id=69a7067a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a7067a",
  null
  
)

export default component.exports